import { Field, Formik } from "formik";
import { Col, Row } from "react-grid-system";
import { useQuery } from "react-query";
import { ChangeUserPasswordInputType, getUser, postChangeUserPassword, UserType } from "../../../api/admin/user";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SForm, SFormFooter } from "../../../styles/ChangePassword";
import { StyledField } from "../../../styles/StyledField";
import { QueryLoader } from "../../Loader";
import { Button } from "../../Button";
import { CopyToClipboard } from "react-copy-to-clipboard";
import * as Yup from "yup";
import CopyIcon from "../../../assets/img/icons/copy-regular.svg";
import SaveIcon from "../../../assets/img/icons/save.svg";
import { useState } from "react";
import { BEErrorType } from "../../ChangePassword";

type ChangeUserPasswordProps = { userId: number; closeModal: () => void };

const validationSchema = Yup.object({
	userId: Yup.number().required(),
	newPassword: Yup.string().min(1).required("New password is a required field"),
});

export const ChangeUserPassword = (props: ChangeUserPasswordProps) => {
	const { userId, closeModal } = props;

	const [beErrors, setBeErrors] = useState<BEErrorType[] | undefined>(undefined);

	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data } = useQuery<UserType>(["user", userId], () => getUser(axiosPrivate, userId));

	const initialValues: ChangeUserPasswordInputType = {
		userId,
		newPassword: "",
	};

	const handleSubmit = async (values: ChangeUserPasswordInputType) => {
		const res = await postChangeUserPassword({ axiosPrivate, data: values });
		if (res?.data?.code === 400) {
			return setBeErrors(res?.data?.fieldErrors);
		}
		closeModal();
		return true;
	};

	const handleBeError = (field: string) => {
		if (beErrors) {
			return beErrors.filter((error) => error.path === field);
		}
	};

	if (isLoading) {
		return (
			<>
				<QueryLoader />
			</>
		);
	}

	if (isError) {
		console.error(error);
		return <>Something went wrong...</>;
	}

	if (!data) {
		return (
			<>
				<Row>
					<Col>
						<h3>User not exists</h3>
					</Col>
				</Row>
				<Row>
					<Col>
						<SFormFooter>
							<Button onClick={() => closeModal()}>Close</Button>
						</SFormFooter>
					</Col>
				</Row>
			</>
		);
	}

	return (
		<>
			<Row>
				<Col>
					<h3>
						Edit {data?.firstName} {data?.lastName}
					</h3>
				</Col>
			</Row>
			<Row style={{ marginTop: "1rem" }}>
				<Col>
					<h5>Change Password</h5>
					<Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
						{({ errors, touched, isValid, values, isSubmitting }) => {
							return (
								<SForm>
									<StyledField>
										<label>New password</label>
										<Field name="newPassword" type="password"></Field>
										{errors.newPassword && touched.newPassword ? <span>{errors.newPassword}</span> : null}
										{handleBeError("children[newPassword].data")
											? handleBeError("children[newPassword].data")?.map((err, i) => <span key={i}>{err.message}</span>)
											: null}
									</StyledField>
									<Row>
										<Col style={{ display: "flex", justifyContent: "center" }}>
											<CopyToClipboard text={values.newPassword}>
												<Button icon={CopyIcon}>Copy password</Button>
											</CopyToClipboard>
										</Col>
									</Row>

									<SFormFooter>
										<Button type="reset" onClick={() => closeModal()}>
											Cancel
										</Button>
										<Button type="submit" disabled={!isValid || isSubmitting} icon={SaveIcon}>
											Change
										</Button>
									</SFormFooter>
								</SForm>
							);
						}}
					</Formik>
				</Col>
			</Row>
		</>
	);
};
